import ResponseItem from './ResponseItem';
import { ResponseItemProps, ResponseItemValueProps } from './types';

export type { ResponseItemProps, ResponseItemValueProps };
export default ResponseItem;
